// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__m8Vdf","main":"Layout_main__T84kS"};